export const AmountColumn = (cellContext: any) => {
  const {
    row: { original: charge },
  } = cellContext;

  return <div>{charge.display_amount_with_currency}</div>;
};
